import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "../../axios";
import "dropify/dist/css/dropify.min.css";
import "dropify/dist/js/dropify.min.js";
import $ from "jquery";

const AddGallery = () => {
  const { id } = useParams();
  const isEditing = !!id;
  const navigate = useNavigate(); // Add useNavigate hook

  const [events, setEvents] = useState([]);
  const [eventId, setEventId] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);

  const fileInputRef = useRef(null);

  // Fetch event list
  useEffect(() => {
    axios
      .get("/events")
      .then((res) => setEvents(res.data))
      .catch((err) => {
        console.error("Failed to fetch events:", err);
        alert("Failed to load events");
      });
  }, []);

  // Fetch existing gallery if editing
  useEffect(() => {
    if (isEditing) {
      axios
        .get(`/galleries/${id}`)
        .then((res) => {
          const gallery = res.data;

          setEventId(gallery.event_id);
          setTitle(gallery.title);
          setDescription(gallery.description);
          setImagePreview(gallery.image_url);
        })
        .catch((err) => {
          alert("Error loading gallery");
        });
    }
  }, [id, isEditing]);

  // Reinitialize Dropify
  useEffect(() => {
    const $input = $(fileInputRef.current);
    const drEvent = $input.data("dropify");
    if (drEvent) drEvent.destroy();

    if (isEditing && imagePreview) {
      $input.attr("data-default-file", imagePreview);
    } else {
      $input.removeAttr("data-default-file");
    }

    setTimeout(() => {
      $input.dropify();
    }, 50);
  }, [imagePreview, isEditing]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);

    if (file && file.type !== "application/zip") {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!eventId || (!isEditing && !image)) {
      alert("All fields are required");
      return;
    }

    const formData = new FormData();
    formData.append("event_id", String(eventId)); // 👈 ensure it's not undefined or null
    formData.append("title", title);
    formData.append("description", description || ""); // prevent undefined
    if (image) formData.append("image", image);

    setUploadProgress(0);

    axios
      .post(
        isEditing ? `/galleries/${id}?_method=PUT` : "/galleries",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percent);
          },
        }
      )
      .then((res) => {
        if (res.data.extracted_images?.length > 0) {
          setImagePreview(res.data.extracted_images);
        } else {
          // window.location.href = "/admin/galleryList";
          navigate("/admin/galleryList");
        }
      })
      .catch((err) => {
        console.error("Error saving gallery:", err.response?.data);
        alert("Failed to save gallery");
        setUploadProgress(0);
      });
  };

  return (
    <div className="main-content">
      <Link to="/admin/galleryList" className="text-decoration-none">
        <button className="btn text-black mb-3 border-0">
          <h5>
            ←{" "}
            <span className="ms-2">
              {isEditing ? "Edit Gallery" : "Add Gallery"}
            </span>
          </h5>
        </button>
      </Link>

      <form onSubmit={handleSubmit}>
        <div className="row gap-lg-5">
          <div className="mb-3 col-12 col-lg-4">
            <label className="form-label">
              Event Name <span className="text-danger">*</span>
            </label>
            <select
              className="form-select"
              value={eventId}
              onChange={(e) => {
                const selectedId = e.target.value;
                setEventId(selectedId);

                const selectedEvent = events.find(
                  (ev) => ev.id === parseInt(selectedId)
                );
                if (selectedEvent) {
                  setTitle(selectedEvent.title);
                }
              }}
              required>
              <option value="">Select an event</option>
              {events.map((event) => (
                <option key={event.id} value={event.id}>
                  {event.title}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* <div className="mb-3 col-12 col-lg-4">
                    <label className="form-label">Description <span className="text-danger">*</span></label>
                    <textarea
                        className="form-control"
                        rows="3"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Enter description"
                        required
                    ></textarea>
                </div> */}

        <div className="mb-3 col-lg-6">
          <label className="form-label">
            Add Image/ZIP{" "}
            <span className="text-danger">{!isEditing && "*"}</span>
          </label>
          <input
            type="file"
            ref={fileInputRef}
            className="form-control dropify"
            accept=".jpg,.jpeg,.png,.zip"
            onChange={handleImageChange}
            {...(!isEditing && { required: true })}
          />
        </div>

        {uploadProgress > 0 && uploadProgress < 100 && (
          <div className="progress my-3" style={{ height: "24px" }}>
            <div
              className="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              style={{ width: `${uploadProgress}%` }}>
              {uploadProgress}%
            </div>
          </div>
        )}

        {Array.isArray(imagePreview) ? (
          <div className="row mt-3">
            {imagePreview.map((img, idx) => (
              <div className="col-3 mb-2" key={idx}>
                <img
                  src={img}
                  alt={`Extracted ${idx}`}
                  className="img-fluid rounded"
                />
              </div>
            ))}
          </div>
        ) : imagePreview ? (
          <div className="mt-3">
            <img
              src={imagePreview}
              alt="Preview"
              style={{ width: "200px", borderRadius: "8px" }}
            />
          </div>
        ) : null}

        <div className="text-end mt-4">
          <button
            type="submit"
            className="btn gold-add-btn py-2 px-4 w-auto rounded-0 text-white">
            {isEditing ? "Update" : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddGallery;
